export enum SortTypes {
  ID = 'ID',
  NAME = 'Name',
  DURATION = 'Duration',
}
